import "core-js/modules/es.array.map.js";
import intersection from 'lodash/intersection';
import React from 'react';
import { createEntityCollection } from '../../utils/entity';
import { QQIcon } from './assets/qq-icon';
import { QzoneIcon } from './assets/qzone-icon';
import { SavePhotoIcon } from './assets/save-photo-icon';
import { WeiboIcon } from './assets/weibo-icon';
import { WeixinCircleIcon } from './assets/weixin-circle-icon';
import { WeixinIcon } from './assets/weixin-icon';
/** 分享渠道 */

export var shareChannelMap = {
  /** 微信好友 */
  WEIXIN: 'weixin',

  /** 微信朋友圈 */
  WEIXIN_CIRCLE: 'weixin_circle',

  /** QQ 好友 */
  QQ: 'qq',

  /** QQ 空间 */
  QZONE: 'qzone',

  /** 新浪微博 */
  WEIBO: 'weibo',

  /** 保存图片 */
  SAVE_PHOTO: 'save_photo'
};
export var shareChannelList = [{
  text: '保存图片',
  value: shareChannelMap.SAVE_PHOTO,
  icon: /*#__PURE__*/React.createElement(SavePhotoIcon, null)
}, {
  text: '朋友圈',
  value: shareChannelMap.WEIXIN_CIRCLE,
  icon: /*#__PURE__*/React.createElement(WeixinCircleIcon, null)
}, {
  text: '微信好友',
  value: shareChannelMap.WEIXIN,
  icon: /*#__PURE__*/React.createElement(WeixinIcon, null)
}, {
  text: 'QQ 空间',
  value: shareChannelMap.QZONE,
  icon: /*#__PURE__*/React.createElement(QzoneIcon, null)
}, {
  text: 'QQ 好友',
  value: shareChannelMap.QQ,
  icon: /*#__PURE__*/React.createElement(QQIcon, null)
}, {
  text: '新浪微博',
  value: shareChannelMap.WEIBO,
  icon: /*#__PURE__*/React.createElement(WeiboIcon, null)
}];
export var shareChannelCollection = createEntityCollection(shareChannelList, function (x) {
  return x.value;
});
export var normalizeChannels = function normalizeChannels(channels) {
  var defaultChannels = shareChannelList.map(function (x) {
    return x.value;
  });
  var result = intersection(defaultChannels, channels);
  return result.length > 0 ? result : defaultChannels;
};